import axios from 'axios'
import { apiUrl } from '@/config'
import { buildAccessQueryParams } from '@/utils/trackAccessAuth'

const instance = axios.create({
  baseURL: apiUrl,
})

instance.interceptors.request.use(config => {
  const accessParams = buildAccessQueryParams()
  if (!Object.keys(accessParams).length) {
    return config
  }

  config.params = {
    ...(config.params || {}),
    ...accessParams,
  }

  return config
})

export default instance
